import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

const GAME_TAG = 'ludo'
const ACT_NAME = 'ludo_coins_bets_act_v4'

export enum stateEnum {
  noUse = 0,
  using,
  canUse,
  expired,
}
enum typeEnum {
  //  1骰子皮肤 2棋子皮肤
  dice = 1,
  chessman,
}
export interface game_skin_type {
  id: number
  icon: string
  title: string
  state: stateEnum
  tag: string
  expire_day: number
  type: typeEnum
  pid: number
}
export enum missionStatus {
  goDo = 0,
  received,
  canGet,
  expired,
}
export enum rewardEnum {
  silverCoin = 7,
  skin,
}
export enum BUTTON_STATE {
  hide = 0,
  goToDo = 1,
  showPrize = 2,
}
export interface IReward {
  img_url: string
  reward_cnt: number
  is_box: boolean
  reward_type?: rewardEnum
  reward_msg?: string
}
interface MissionActivityItemSt {
  mission_id: number
  reward: IReward
  status: missionStatus
  desc: string
  target: number
  current: number
}
export interface RankItem {
  rank: number
  score: number
  name: string
  image: string
  button_state: number
  mid: number
}
interface CommonRank {
  list: Array<RankItem>
  my_rank_info: RankItem
  rewards: Array<IReward>
  button_state: BUTTON_STATE
}
export interface IRoom {
  room_id: number
  title: string
  cover: string
  scheme: string
}

export enum PageTypeEnum {
  join = 'join',
  task = 'task',
  rank = 'rank',
}

// 背包列表 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90611208
export const knapsack_list = createAsyncThunk(
  'GoldLudo_knapsack_list',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'list' | 'tips'>>
    >(
      '/gamestore/common/knapsack_list',
      {
        ...store.getState().env.deviceinfo,
        activity_name: ACT_NAME,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 冷启活动任务列表
export const getTaskList = createAsyncThunk(
  'GoldLudo_common_activity_detail',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        common_activity_detail?: {
          list?: Array<MissionActivityItemSt>
        }
        activity_time?: string
      }>
    >(
      '/gamestore/common/common_activity_detail',
      {
        ...store.getState().env.deviceinfo,
        activity_name: ACT_NAME,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 领取任务奖励
export const common_activity_reward = createAsyncThunk(
  'GoldLudo_common_activity_reward',
  async (arg: {mission_id: number; room_id: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        err_msg: string
        common_activity?: {
          List?: Array<MissionActivityItemSt>
        }
        reward?: IReward
      }>
    >('/gamestore/common/common_activity_reward', {
      ...store.getState().env.deviceinfo,
      ...arg,
      activity_name: ACT_NAME,
    })
    return resp.data.data
  }
)
// 使用皮肤
export const use_game_skin = createAsyncThunk(
  'GoldLudo_use_mall_game_skin',
  async (arg: {room_id: number; pid: number; type: typeEnum}, store: any) => {
    const resp = await http.post<HiyaRes<{err_msg: string}>>(
      '/gamestore/common/use_mall_game_skin',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
        game_tag: GAME_TAG,
        from: ACT_NAME,
      }
    )
    return resp.data.data
  }
)

// // 冷启活动任务去完成
// export const cold_boot_goto_complete = createAsyncThunk(
//   'GoldLudo_cold_boot_goto_complete',
//   async (arg: {room_id: number}, store: any) => {
//     const resp = await http.post<
//       HiyaRes<{
//         scheme: number
//         err_msg: string
//       }>
//     >('/gamestore/common/game_mission_goto_complete', {
//       ...store.getState().env.deviceinfo,
//       ...arg,
//       game_tag: GAME_TAG,
//       from: 'cold_boot_activity',
//     })
//     return resp.data.data
//   }
// )

// 活动排行榜-局数
export const common_ranking_round = createAsyncThunk(
  'GoldLudo_cold_boot_common_ranking',
  async (arg: any, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        list: any
        my_rank_info: any
        rewards: any
        err_msg: string
        button_state: number
      }>
    >('/gamestore/common/common_ranking', {
      ...store.getState().env.deviceinfo,
      ...arg,
      game_tag: GAME_TAG,
      activity_name: ACT_NAME,
      sub_act_name: 'rounds',
    })
    return resp.data.data
  }
)
// 活动排行榜-金币 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92462665
export const common_ranking_coin = createAsyncThunk(
  'GoldLudo_cold_boot_common_ranking_coin',
  async (arg: any, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        list: any
        my_rank_info: any
        rewards: any
        err_msg: string
        button_state: number
      }>
    >('/gamestore/common/common_ranking', {
      ...store.getState().env.deviceinfo,
      ...arg,
      game_tag: GAME_TAG,
      activity_name: ACT_NAME,
      sub_act_name: 'coins',
    })
    return resp.data.data
  }
)
// ludo金币场推荐房间列表 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92462513
export const ludo_coins_activity_room_list = createAsyncThunk(
  'GoldLudo_cold_boot_common_ludo_coins_activity_room_list',
  async (arg: any, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        list: any
      }>
    >('/gamestore/common/ludo_coins_activity_room_list', {
      ...store.getState().env.deviceinfo,
      ...arg,
      // game_tag: GAME_TAG,
    })
    return resp.data.data
  }
)

interface InitialStateType {
  // 背包列表
  list?: Array<{game_skin?: game_skin_type}>
  tips?: string
  // 任务列表
  common_activity_detail?: {
    list?: Array<MissionActivityItemSt>
  }
  activity_time?: string
  roundRank?: CommonRank
  coinRank?: CommonRank
  roomList?: Array<IRoom>
  taskCanGet?: boolean
}
const initialState: InitialStateType = {}

export const GoldLudoSlice = createSlice({
  name: 'GoldLudo',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(knapsack_list.fulfilled, (state, action) => {
        Object.assign(state, action.payload)
      })
      .addCase(getTaskList.fulfilled, (state, action) => {
        Object.assign(state, {
          ...action.payload,
          taskCanGet:
            action.payload?.common_activity_detail?.list?.findIndex(
              (item) => item.status === missionStatus.canGet
            ) >= 0,
        })
      })
      .addCase(common_activity_reward.fulfilled, (state, action) => {
        if (action.payload.common_activity && !action.payload.err_msg) {
          Object.assign(state, {
            common_activity_detail: action.payload.common_activity,
          })
        }
      })
      .addCase(common_ranking_round.fulfilled, (state, action) => {
        Object.assign(state, {roundRank: action.payload})
      })
      .addCase(common_ranking_coin.fulfilled, (state, action) => {
        Object.assign(state, {coinRank: action.payload})
      })
      .addCase(ludo_coins_activity_room_list.fulfilled, (state, action) => {
        Object.assign(state, {roomList: action.payload.list})
      })
  },
})
export default GoldLudoSlice.reducer
export const GoldLudoActions = GoldLudoSlice.actions
